import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCatogoryCardComponent } from '../../order-catogory-card/order-catogory-card.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    OrderCatogoryCardComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    OrderCatogoryCardComponent
  ]
})
export class OrderCatogoryCardModule { }
